tmpSc